import styled from "styled-components";

export const ContainerForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionInput = styled.div`
  width: 95%;
  margin-top: 10px;

  label {
    font-size: 18px;
  }
`;

export const Alert = styled.div`
  width: 100%;
  padding: 0px 30px;
`;

